import { IconsProps } from '@/types/shared'

const ProfitabilityIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {/* Dollar sign with trending up arrow for profitability */}
                <line x1="12" y1="2" x2="12" y2="22" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                <polyline points="23 6 18 1 13 6" />
                <line x1="18" y1="1" x2="18" y2="9" />
            </svg>
        </div>
    )
}

export default ProfitabilityIcons
